/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { Rating } from '../../content/Rating'
import { DropdownFilterDate } from '../../content/dropdown/DropdownFilterDate'
import { LanguageHelp } from '../../../helpers/LanguageHelper'
import { Link } from 'react-router-dom'

type Props = {
  uniqueKey: string
  tableName?: string
  className: string
  chartSize?: number
  datas?: TablesWidget14Dto
  texts?: string[]
  firstColor?: string
  secondColor?: string
  thirdColor?: string
  fourthColor?: string
  mainLabel?: string
  sideLabel?: string
  functionSubmit?: any
  functionDownload?: any
  isDownloadContinue?: boolean
  url?: string
  warnings: { url: string, message: string }[]
  isWaringImageMirror?: boolean
}

export class TablesWidget14ItemDto { label = ""; firstCount = 0; secondCount = 0; thirdCount = 0; fourthCount = 0; firstRate = 0; secondRate = 0; thirdRate = 0; fourthRate = 0 }

export class TablesWidget14Dto { items: TablesWidget14ItemDto[] = [new TablesWidget14ItemDto]; totalCount = 0; totalRate = 0; }

const TablesWidget14: React.FC<Props> = ({
  uniqueKey,
  tableName = "",
  className,
  chartSize = 90,
  datas = new TablesWidget14Dto(),
  texts = ["Net Profit", "Net Profit"],
  mainLabel = "Your Statistics",
  sideLabel = "More than 400 new members",
  functionSubmit,
  functionDownload,
  isDownloadContinue = false,
  url = "",
  warnings = [],
  isWaringImageMirror = false
}) => {

  // console.log('datas.items![0].label === ""', datas.items![0].label === "")
  // console.log('datas.items![0].label !== "" && datas.items!.length === 1', datas.items![0].label !== "" && datas.items!.length === 1)
  return (
    <div className={`card ${className} minh-md-600px`} key={uniqueKey}>
      {/* begin::Header */}
      <div className='card-header pt-5'>
        <div className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold text-dark'>{mainLabel}</span>
          <div>
            <span className='text-gray-400 fw-semibold fs-6'>{sideLabel}:</span>
            {datas.totalCount !== 0 &&
              <div style={{ display: 'unset' }}>
                <span className='card-label fw-bolder text-gray-700 mt-2 pt-1'>{datas.totalCount}</span>
                <Rating rate={datas.totalRate} />
              </div>
            }
          </div>
        </div>
        <div className='card-toolbar'>
          <DropdownFilterDate className='me-2 mb-2' functionSubmit={functionSubmit} />
          <button
            type='button'
            className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary mb-2'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
            onClick={(e) => { functionDownload() }}
            disabled={isDownloadContinue}
          >
            {!isDownloadContinue && (
              <KTSVG
                path='/media/icons/duotune/arrows/arr044.svg'
                className='svg-icon-3'
              />
            )}
            {isDownloadContinue && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
      {/* end::Header */}

      {datas.items![0].label === "" &&
        <div className='card-body py-3 scroll-y mh-450px maxh-md-600px'>
          <div className='d-flex flex-center me-5 pt-2'>
            <span className='indicator-progress' style={{ display: 'block', margin: 'auto' }}>
              {/* Please wait...{' '} */}
              <span className='spinner-border spinner-border-lg align-middle ms-2'></span>
              <div
                style={{ minWidth: chartSize + 'px', minHeight: chartSize + 'px' }}
              ></div>
            </span>
          </div>
        </div>
      }

      {(datas.items![0].label !== "" && datas.items!.length === 1) && (
        <div className='text-center p-11'>
          {warnings.map((warning, key) => (
            <Link key={key} to={warning.url}>
              <div>
                {warning.message}
                &nbsp;<KTSVG path='/media/icons/duotune/arrows/arr095.svg' className='svg-icon-2' />
              </div>
            </Link>
          ))}
          <div>
            <img
              className='mw-100 mh-200px'
              alt='metronic'
              style={{ transform: isWaringImageMirror ? 'scaleX(-1)' : 'scaleX(1)' }}
              src={toAbsoluteUrl('/media/illustrations/sketchy-1/1.png')}
            />
          </div>
        </div>
      )}

      {datas.items![0].label !== "" && datas.items.length !== 1 && (
        <div className='card-body py-3 scroll-y mh-450px maxh-md-600px'>
          <div className='tab-content'>
            {/* begin::Tap pane */}
            <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
              {/* begin::Table container */}
              <div className='table-responsive'>
                {/* begin::Table */}
                <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                  {/* begin::Table head */}
                  <thead>
                    <tr className=''>
                      <th className=''>{tableName}</th>
                      <th className=''>{LanguageHelp("Total")}</th>
                      <th className=''>{LanguageHelp("Positive")}</th>
                      <th className=''>{LanguageHelp("Negative")}</th>
                      <th className=''>{LanguageHelp("Neutral")}</th>
                    </tr>
                  </thead>
                  {/* end::Table head */}
                  {/* begin::Table body */}
                  <tbody>
                    {datas.items.map((data, index) => (
                      <tr key={uniqueKey + '_' + index}>
                        <td>
                          <div className='d-flex align-items-center'>
                            <div className='d-flex flex-column'>
                              <span>{data.label}</span>
                            </div>
                          </div>
                        </td>
                        <td className='text-dark fw-bold mb-1'>{data.firstCount}
                          <Rating rate={data.firstRate} />
                        </td>
                        <td className='text-dark fw-bold mb-1'>{data.secondCount}
                          <Rating rate={data.secondRate} />
                        </td>
                        <td className='text-dark fw-bold mb-1'>{data.thirdCount}
                          <Rating rate={data.thirdRate} reversed={true} />
                        </td>
                        <td className='text-dark fw-bold mb-1'>{data.fourthCount}
                          <Rating rate={data.fourthRate} />
                        </td>

                        {url !== "" &&
                          <td className='text-end'>
                            <a href={url + 'filter_subject=' + data.label} className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'>
                              <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-2' />
                            </a>
                          </td>
                        }
                      </tr>
                    ))}
                  </tbody>
                  {/* end::Table body */}
                </table>
              </div>
              {/* end::Table */}
            </div>
            {/* end::Tap pane */}
          </div>
        </div>
      )}
    </div>
  )
}

export { TablesWidget14 }
